export const getQueryParams = (search) => new URLSearchParams(search);
export const getParamFromQueryString = (queryString, paramName) => {
    const params = getQueryParams(queryString);
    return params.get(paramName);
};
export const getIdFromQueryString = (queryString) => getParamFromQueryString(queryString, 'id');
